<template>
    <div>
        <div class="alert alert-custom" role="alert"
             :class="{'alert-success': wasAccepted, 'alert-light-primary': !wasAccepted}">
            <div class="alert-icon">
                <i v-if="wasAccepted" class="fas fa-check-circle"/>
                <i v-else class="fas fa-clock"/>
            </div>
            <div class="alert-text">
                <div v-if="wasAccepted" class="d-flex flex-row">
                    <div class="flex-grow-1 text-lg d-flex flex-column justify-content-center">
                        <span>Diese Änderung wurde angenommen</span>
                    </div>
                </div>
                <div v-else class="d-flex flex-row">
                    <div class="flex-grow-1">
                        <div class="text-lg font-weight-bold">Diese Änderung wurde bisher nicht angenommen</div>
                    </div>
                </div>
            </div>
        </div>

        <h2>Bisherige Artikeldaten</h2>
        <hr/>

        <div class="row mt-5">
            <div class="col-md-4 mb-5">
                <label>EAN</label>
                <h5>{{ article.ean }}</h5>
            </div>
            <div class="col-md-4 mb-5">
                <label>Datenqualität</label>
                <h5>{{ articleSourceQualityString }}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-5">
                <label>Produktname</label>
                <h5>{{ article.product.name }}</h5>
            </div>
            <div class="col-md-4 mb-5">
                <label>Artikelname</label>
                <h5>{{ article.name }}</h5>
            </div>
            <div class="col-md-4 mb-5">
                <label>Herstellernummer</label>
                <h5>{{ article.manufacturer_article_number ? article.manufacturer_article_number : '-' }}</h5>
            </div>
            <div class="col-md-4 mb-5">
                <label>Marke</label>
                <h5>{{ article.product.brand.name }}</h5>
            </div>
            <div class="col-md-4 mb-5">
                <label>Kategorie</label>
                <h5>{{ article.product.category.name }}</h5>
            </div>
        </div>

        <div class="row">
            <div v-for="attribute in article.attributes" class="col-md-4 mb-5">
                <label>{{ attribute.name }}</label>
                <h5>{{ attribute.pivot.value }}</h5>
            </div>
        </div>

        <div class="row mb-5">
            <div class="col-md-12">
                <label>Produktbeschreibung</label>
                <div class="card">
                    <div class="card-body">
                        {{ article.product.description }}
                    </div>
                </div>
            </div>
        </div>

        <label>Artikelbilder</label>
        <div class="row mb-10">
            <div v-for="image in article.images" class="col-sm-6 col-lg-4 mb-5">
                <img :src="image.url" class="w-300px h-200px" style="object-fit: contain">
            </div>
        </div>

        <h2>Gewünschte Änderungen</h2>
        <hr/>

        <div class="row mt-5">
            <div v-if="article.product.name !== articleUpdateRequest.product_name" class="col-md-4 mb-5">
                <label>Produktname</label>
                <h5>{{ articleUpdateRequest.product_name }}</h5>
            </div>
            <div v-if="article.name !== articleUpdateRequest.article_name" class="col-md-4 mb-5">
                <label>Artikelname</label>
                <h5>{{ articleUpdateRequest.article_name }}</h5>
            </div>
            <div v-if="article.manufacturer_article_number !== articleUpdateRequest.sku" class="col-md-4 mb-5">
                <label>Herstellernummer</label>
                <h5>{{ articleUpdateRequest.sku }}</h5>
            </div>
            <div v-if="article.product.brand.name !== brand.name" class="col-md-4 mb-5">
                <label>{{ __('general.brand') }}</label>
                <h5>{{ brand.name }}</h5>
            </div>
            <div v-if="article.product.category.id !== articleUpdateRequest.category_id" class="col-md-4 mb-5">
                <label>Kategorie</label>
                <h5>{{ categoryName }}</h5>
            </div>
        </div>

        <div v-if="article.product.description !== articleUpdateRequest.product_description" class="row mt-5">
            <div class="col-md-12">
                <label>Produktbeschreibung</label>
                <div class="card">
                    <div class="card-body">
                        {{ articleUpdateRequest.product_description }}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-for="(attribute, index) in article.attributes" class="col-md-4 mb-5">
                <div v-if="attribute.pivot.value !== articleUpdateRequest.attributes[index].value">
                    <label>{{ attribute.name }}</label>
                    <h5>{{ articleUpdateRequest.attributes[index].value }}</h5>
                </div>
            </div>
        </div>

        <div v-if="deleteImageUrls.length > 0" class="row">
            <h5>Zu löschende Bilder</h5>
            <div v-for="image in deleteImageUrls" class="col-sm-6 col-lg-4 mb-5">
                <img :src="image" class="w-300px h-200px" alt="Zu löschendes Bilde" style="object-fit: contain">
            </div>
        </div>

        <div v-if="articleUpdateRequest.new_images_paths && !userRequest.approved" class="row">
            <h5>Neu hinzugefügte Bilder</h5>
            <div v-for="image in articleUpdateRequest.new_images_paths" class="col-sm-6 col-lg-4 mb-5">
                <img :src="`${image.replace('public', 'storage')}`" alt="Neues Bild" class="w-300px h-200px"
                     style="object-fit: contain">
            </div>
        </div>

    </div>
</template>

<script>
import UserRequestLayout from '@layouts/UserRequestLayout.vue'

export default {
    layout: UserRequestLayout,

    props: {
        article: Object,
        brand: Object,
        deleteImageUrls: Array,
        articleUpdateRequest: Object,
        articleSourceQualityString: String,
        categoryName: String,
    },

    computed: {
        wasAccepted() {
            return this.userRequest.approved !== null && this.userRequest.approved
        },

        userRequest() {
            return this.articleUpdateRequest.userRequest
        },
    },
}
</script>
